export enum ProductionTechnicianArea {
    Unknown = 0,
    Gotaland = 1,
    SodraBergslagen = 2,
    NorraBergslagen = 3,
    SodraNorrland = 4,
    Vasterbotten = 5,
    Norrbotten = 6
}

export const ProductionTechnicianAreaLabels = {
    [ProductionTechnicianArea.Unknown]: "Okänt",
    [ProductionTechnicianArea.Gotaland]: "Götaland",
    [ProductionTechnicianArea.SodraBergslagen]: "Södra Bergslagen",
    [ProductionTechnicianArea.NorraBergslagen]: "Norra Bergslagen",
    [ProductionTechnicianArea.SodraNorrland]: "Södra Norrland",
    [ProductionTechnicianArea.Vasterbotten]: "Västerbotten",
    [ProductionTechnicianArea.Norrbotten]: "Norrbotten"
}

export const GetProductionTechnicianAreaEnum = (productionTechnicianAreaLabel: string): ProductionTechnicianArea => {
    const areaEntry = Object.entries(ProductionTechnicianAreaLabels)
        .find(([key, value]) => value === productionTechnicianAreaLabel);
    const areaEnumValue = areaEntry ? Number(areaEntry[0]) : ProductionTechnicianArea.Unknown;

    return areaEnumValue
}